//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectBodyList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BoundingBoxType",1,0],[0,"BoxPosition",1,0],[0,"ClearanceToggle",1,0],[0,"ConceptDesign",1,0],[0,"DieInsertType",1,0],[0,"DieShimDistance",1,0],[0,"DieStandardInsertInstance",1,"TaggedObject",0],[0,"InsertMode",1,0],[0,"NewPartNames",1,0],[1,"OffsetValueLinearDimensionNegativeX",0,"Expression",0],[1,"OffsetValueLinearDimensionNegativeY",0,"Expression",0],[1,"OffsetValueLinearDimensionNegativeZ",0,"Expression",0],[1,"OffsetValueLinearDimensionPositiveX",0,"Expression",0],[1,"OffsetValueLinearDimensionPositiveY",0,"Expression",0],[1,"OffsetValueLinearDimensionPositiveZ",0,"Expression",0],[0,"ParentPartName",1,0],[0,"Position",1,0],[0,"PositionPrecisionValue",1,0],[0,"PrecisionValue",1,0],[1,"RadialOffset",0,"Expression",0],[0,"RenameDialog",1,0],[1,"SelectDieInsertOutline",0,"Section",0],[1,"SelectScrap",0,"SelectBodyList",0],[1,"SelectUserDefinedDieInsertForEdit",0,"SelectBodyList",0],[0,"SelectVector",1,"Direction",0],[0,"UserDefinedDieInsertClearance",1,0],[1,"UserDefinedDieInsertHeight",0,"Expression",0],[0,"WithoutFalseBody",1,0]],[[[],"StandardDieInsert",{},0,0],[[],"CreateUserDefinedInsertDatumPlane",{},0,0],[[],"AddDieInsertPart",{},0,0],[[],"CreateUserDefinedDieInsert",{},0,0],[["matrix","position"],"SetManipulatorToMatrixAndPosition",{},2,0],[[],"CalculateBoxSize",{},0,0]],[]];
SPLM.Tooling.DieInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieInsertBuilder.PositionItems = Object.freeze({
    "Top" : "Top", "Bottom" : "Bottom"});

SPLM.Tooling.DieInsertBuilder.InsertModeItems = Object.freeze({
    "StandardInsert" : "StandardInsert", "SketchProfile" : "SketchProfile", "BoundingBox" : "BoundingBox"});

SPLM.Tooling.DieInsertBuilder.DieInsertTypeItems = Object.freeze({
    "DieInsert" : "DieInsert", "BackingInsert" : "BackingInsert"});

SPLM.Tooling.DieInsertBuilder.BoundingBoxTypeItems = Object.freeze({
    "Block" : "Block", "Cylinder" : "Cylinder"});

export default SPLM;